<template>
  <b-modal id="clinic-show-user" class="clinic-show-user" ref="modal" :title="dialog_title" hide-footer>
    <div class="form-group row">
      <div class="col-sm-12">
        <div class="form-check form-check-inline">
          <input v-model="is_active" class="form-check-input" type="checkbox" id="user_is_active" value="1" />
          <label class="form-check-label" for="user_is_active">Usuario Activo - ( Desmarca para desactivar)</label>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4">
        <input placeholder="Nombre" v-model="name" model="name" type="text" id="show_user_name" class="form-control"
          required />
        <label class="wabident-info" for="show_user_name">Nombre</label>
      </div>

      <div class="col-sm-4">
        <input placeholder="Email" v-model="email" name="email" type="email" id="show_user_email" class="form-control"
          required />
        <label class="wabident-info" for="show_template_title">Email ( Se usa para entrar en la aplicación )</label>
      </div>

      <div class="col-sm-4">
        <input placeholder="Contraseña" v-model="password" name="password" type="text" id="show_user_password"
          class="form-control" :required="is_editing" />
        <label class="wabident-info" for="show_user_password">Contraseña
          <span v-if="is_editing">( Vacía para no cambiar)</span></label>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-4">
        <select v-model="clinic_id" name="clinic_id" id="show_user_clinic_id" class="custom-select" required>
          <option :value="null">Elige clínica</option>
          <option :value="id" :key="id" v-for="(name, id) in clinic_list">
            {{ name }}
          </option>
        </select>
        <label for="show_user_clinic_id" class="wabident-info">Clínica de Referencia</label>
      </div>

      <div class="col-sm-4">
        <select v-model="role" name="role" id="show_user_role" class="custom-select" required>
          <option :value="null">Elige rol</option>
          <option value="reception">Recepción</option>
          <option value="doctor">Doctor/a</option>
          <option value="nurse">Enfermero/a</option>
          <option value="auxiliary">Auxiliar</option>
          <option value="admin">Administrador/a</option>
        </select>
        <label for="show_user_role" class="wabident-info">Rol</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-12">
        <legend>Clinicas Accesibles</legend>
      </div>

      <div class="col-sm-4" v-for="(name, index) in this.clinic.clinic_names" :key="index">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" :id="'user_clinic_enabled_' + index"
            :checked="getEnabledClinic(index)" @change="setEnabledClinic($event, index)" />
          <label class="form-check-label" :for="'user_clinic_enabled_' + index">{{ name }}</label>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="is_role_doctor" class="form-group row">
        <div class="col-sm-12">
          <legend>Datos {{ doctor_title }}</legend>
        </div>

        <div class="col-sm-2">
          <select v-model="box_id" name="box_id" id="show_user_box" class="custom-select" required>
            <option :value="null">Elige Box &hellip;</option>
            <option :value="box.id" :key="index" v-for="(box, index) in boxes">
              {{ box.name }}
            </option>
          </select>
          <label for="show_user_box" class="wabident-info">Box asignado</label>
        </div>

        <div class="col-sm-4">
          <input placeholder="Especialidad" v-model="d_title" type="text" id="show_title" class="form-control">
          <label class="wabident-info" for="show_title">Especialidad/Título</label>
        </div>

        <div class="col-sm-6">
          <v-select multiple class="wabident-selector" :options="product_categories"
            placeholder="Busca la unidad aquí ..." v-model="product_category_ids"></v-select>
          <label class="wabident-info">Unidades asignadas, dejar vacío para permitir todas</label>
        </div>

        <div class="col-sm-4">
          <div class="form-check form-check-inline">
            <input v-model="default_available" class="form-check-input" type="checkbox" id="default_available" />
            <label class="form-check-label" for="default_available">Disponible por defecto</label>
          </div>
        </div>

        <div class="col-sm-8">
          <div class="form-check form-check-inline">
            <input v-model="use_custom_color" class="form-check-input" type="checkbox" id="app_new_color"
              value="true" />
            <label class="form-check-label" for="app_new_color">Color Personalizado Agenda</label>
          </div>
          <wabident-color-picker v-if="use_custom_color" v-model="colors">
          </wabident-color-picker>
        </div>

        <div class="col-sm-12 mt-3">
          <legend>Firma</legend>
        </div>

        <div class="col-sm-4">
          <input placeholder="Nº Colegiado/a (Opcional)" v-model="college_number" model="college_number" type="text"
            id="show_user_college_number" class="form-control" required />
          <label class="wabident-info" for="show_user_college_number">Nº de Colegiado/a</label>
        </div>

        <div class="col-sm-6">
          <b-form-file v-model="signature_file" :state="Boolean(signature_file)" accept=".jpg, .png, .gif, .jpeg"
            placeholder="Elige un archivo de firma. JPG, GIF o PNG" class="wabident-file-input"
            :disabled="is_loading"></b-form-file>
        </div>

        <div v-if="this.current_signature" class="col-sm-2">
          <img :src="this.current_signature" style="max-height: 39px" />
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="caps_for_role[role]" class="form-group row">
        <div class="col-sm-12">
          <legend>Permisos de Usuario</legend>
        </div>
        <div v-for="(capability, cap_name) in caps_for_role[role]" :key="cap_name" class="col-sm-12 pl-4">
          <input v-model="capabilities[cap_name]" class="form-check-input" type="checkbox" :id="'cap_' + cap_name"
            value="1" />
          <label class="form-check-label" :for="'cap_' + cap_name">
            <strong>{{ capability.title }}</strong> {{ capability.desc }}</label>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="is_role_doctor && twilio_enabled" class="form-group row">
        <div class="col-sm-12">
          <legend>Twilio</legend>
        </div>

        <div class="col-sm-12">
          <input placeholder="Template ID para Confirmaciones" v-model="user_config['twilio_confirm_template']"
            type="text" id="twilio_confirm_template" class="form-control" />
          <label class="wabident-info" for="twilio_confirm_template">Plantilla Confirmación Twilio (Avanzado)</label>
        </div>
        <div class="col-sm-12">
          <input placeholder="Template ID para Recordatorios" v-model="user_config['twilio_remember_template']"
            type="text" id="twilio_remember_template" class="form-control" />
          <label class="wabident-info" for="twilio_remember_template">Plantilla Recordatorio Twilio (Avanzado)</label>
        </div>
      </div>
    </transition>

    <div class="form-group row">
      <div class="col text-center">
        <button :disabled="is_loading" type="button" @click="onSubmit" class="btn btn-primary btn-wabident">
          <span v-if="is_loading">Guardando ...</span>
          <span v-else-if="is_editing">Modificar Usuario</span>
          <span v-else>Crear Usuario</span>
          <i v-if="is_loading" class="fas fa-spin fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      user: null,
      is_active: true,
      is_editing: false,
      is_loading: false,
      default_available: true,
      name: null,
      email: null,
      role: null,
      password: null,
      clinic_id: null,
      box_id: null,
      product_category_ids: [],
      college_number: null,
      signature_file: null,
      current_signature: null,
      use_custom_color: false,
      capabilities: [],
      user_config: null,
      boxes: [],
      product_categories: [],
      colors: {
        hex: "#000000",
      },
      d_title: '',
      nickname: '',
      caps_for_role: {
        reception: {
          agenda_only: {
            title: "Ocultar facturación en Ficha Pacientes",
            desc: "Sólo puede acceder a Agenda, Pacientes y Tratamientos",
          },
          accounting: {
            title: "Contabilidad Limitada (Trimestral)",
            desc: "Acceso limitado a Contabilidad del Trimestre Actual y Anterior",
          },
          daily_accounting: {
            title: "Contabilidad Limitada (Diaria)",
            desc: "Acceso limitado a Contabilidad Diaria y del día anterior",
          },
          admin_products: {
            title: "Administrar Tratamientos",
            desc: "Acceso a para crear y modificar Tratamientos y Productos",
          },
        },
        auxiliary: {
          agenda_only: {
            title: "Ocultar Facturación en Ficha Pacientes",
            desc: "Sólo puede acceder a Agenda, Pacientes y Tratamientos",
          },
          agenda_restricted: {
            title: "Restringir ediciones agenda",
            desc: "No puede crear ni cambiar fechas ni datos de NINGUNA cita, incluídas las suyas. Sólo  puede cambiar su estado",
          },
          agenda_unique: {
            title: "Restringir vista agenda",
            desc: "No puede ver las agendas de otros Profesionales, ni tampoco editarlas",
          },
          general_doctor: {
            title: "Auxiliar Jefe",
            desc: "Puede modificar historias de todos los Profesionales",
          },
          private_history: {
            title: "Historia Privada",
            desc: "Historia y Documentos privados ( Para psicologia, psiquiatría, etc )",
          },
          accounting: {
            title: "Contabilidad Limitada (Trimestral)",
            desc: "Acceso limitado a Contabilidad del Trimestre Actual y Anterior",
          },
          daily_accounting: {
            title: "Contabilidad Limitada (Diaria)",
            desc: "Acceso limitado a Contabilidad Diaria y del día anterior",
          },
          admin_products: {
            title: "Administrar Tratamientos",
            desc: "Acceso a para crear y modificar Tratamientos y Productos",
          },
        },
        nurse: {
          agenda_only: {
            title: "Ocultar Facturación en Ficha Pacientes",
            desc: "Sólo puede acceder a Agenda, Pacientes y Tratamientos",
          },
          agenda_restricted: {
            title: "Restringir ediciones agenda",
            desc: "No puede crear ni cambiar fechas ni datos de NINGUNA cita, incluídas las suyas. Sólo  puede cambiar su estado",
          },
          agenda_unique: {
            title: "Restringir vista agenda",
            desc: "No puede ver las agendas de otros Profesionales, ni tampoco editarlas",
          },
          general_doctor: {
            title: "Enfermera/o Jefe",
            desc: "Puede modificar historias de todos los Profesionales",
          },
          private_history: {
            title: "Historia Privada",
            desc: "Historia y Documentos privados ( Para psicologia, psiquiatría, etc )",
          },
          accounting: {
            title: "Contabilidad Limitada (Trimestral)",
            desc: "Acceso limitado a Contabilidad del Trimestre Actual y Anterior",
          },
          daily_accounting: {
            title: "Contabilidad Limitada (Diaria)",
            desc: "Acceso limitado a Contabilidad Diaria y del día anterior",
          },
          admin_products: {
            title: "Administrar Tratamientos",
            desc: "Acceso a para crear y modificar Tratamientos y Productos",
          },
        },
        admin: {
          limited_admin: {
            title: "Contabilidad Limitada (Trimestral)",
            desc: "Sólo puede revisar información financiera del trimestre actual y pasado",
          },
          daily_accounting: {
            title: "Contabilidad Limitada (Diaria)",
            desc: "Acceso limitado a Contabilidad Diaria y del día anterior",
          },
        },
        doctor: {
          agenda_only: {
            title: "Ocultar Facturación en Ficha Pacientes",
            desc: "Sólo puede acceder a Agenda, Pacientes y Tratamientos",
          },
          agenda_restricted: {
            title: "Restringir ediciones agenda",
            desc: "No puede crear ni cambiar fechas ni datos de NINGUNA cita, incluídas las suyas. Sólo  puede cambiar su estado",
          },
          agenda_unique: {
            title: "Restringir vista agenda",
            desc: "No puede ver las agendas de otros profesionales, ni tampoco editarlas",
          },
          general_doctor: {
            title: "Doctor/a Jefe",
            desc: "Puede modificar historias de todos los Profesionales",
          },
          private_history: {
            title: "Historia Privada",
            desc: "Historia y Documentos privados ( Para psicologia, psiquiatría, etc )",
          },
          accounting: {
            title: "Contabilidad Limitada (Trimestral)",
            desc: "Acceso limitado a Contabilidad del Trimestre Actual y Anterior",
          },
          daily_accounting: {
            title: "Contabilidad Limitada (Diaria)",
            desc: "Acceso limitado a Contabilidad Diaria y del día anterior",
          },
          admin_products: {
            title: "Administrar Tratamientos",
            desc: "Acceso a para crear y modificar Tratamientos y Productos",
          },
        },
      },
    };
  },
  watch: {
    clinic_id(value) {
      this.updateBoxes();
    },
  },
  computed: {
    is_role_doctor() {
      return (
        this.role != null &&
        (this.role == "doctor" ||
          this.role == "nurse" ||
          this.role == "auxiliary")
      );
    },
    twilio_enabled() {
      return (
        this.clinic &&
        this.clinic.config &&
        this.clinic.config.appointments_twilio_messaging
      );
    },
    clinic_list() {
      if (!this.clinic) return;
      return this.clinic.clinic_names;
    },
    dialog_title() {
      return this.is_editing ? "Modificar Usuario" : "Nuevo Usuario";
    },
    doctor_title() {
      switch (this.role) {
        case "doctor":
          return "Doctor/a";
        case "nurse":
          return "Enfermero/a";
        case "nurse":
          return "Auxiliar";
      }
      return "";
    },
    ...mapGetters(["msgwindow", "clinic", "errorwindow"]),
  },
  methods: {
    updateCategories() {
      this.product_categories = [];
      axios.get(`/product/hierarchy`).then((response) => {
        response.data.forEach((cat) => {
          if (!cat.parent_id) {
            this.product_categories.push({
              label: cat.name,
              value: cat.id,
            });
          }
        });
      });
    },
    updateBoxes() {
      if (this.clinic_id) {
        axios.get(`/clinic/${this.clinic_id}/boxes`).then((response) => {
          this.boxes = response.data;
        });
      } else {
        this.boxes = 0;
      }
    },
    showNew() {
      this.is_active = true;
      this.user = null;
      this.is_editing = false;
      this.is_loading = false;
      this.name = null;
      this.email = null;
      this.role = null;
      this.clinic_id = null;
      this.box_id = null;
      this.college_number = null;
      this.password = null;
      this.signature_file = null;
      this.current_signature = null;
      this.use_custom_color = false;
      this.capabilities = [];
      this.colors = { hex: "#000000" };
      this.product_category_ids = [];
      this.default_available = true;
      this.d_title = '';
      this.nickname = '';

      this.getUserConfig(null);
      this.updateCategories();
      this.updateBoxes();
      this.$refs.modal.show();
    },
    showEdit(user) {
      this.user = user;
      this.is_active = user.is_active ? true : false;
      this.name = user.name;
      this.email = user.email;

      this.role = user.role;
      if (this.role == "doctor") {
        this.role = user.doctor.type;
      }

      this.capabilities = [];
      if (user.capabilities) {
        user.capabilities.forEach((cap) => {
          this.capabilities[cap.name] = 1;
        });
      }

      this.getUserConfig(user);

      this.clinic_id = user.clinic_id;
      this.password = null;
      this.signature_file = null;
      this.current_signature = null;
      this.product_category_ids = [];
      this.box_id = null;
      this.d_title = '';
      this.doctor_title = '';

      if (
        (user.role == "doctor" ||
          user.role == "nurse" ||
          user.role == "auxiliary") &&
        this.user.doctor
      ) {
        this.college_number = this.user.doctor.college_number;
        this.box_id = this.user.doctor.box_id || null;

        this.use_custom_color = !(
          this.user.doctor.color == null ||
          this.user.doctor.color == "#000000" ||
          this.user.doctor.color == "null"
        );

        if (this.use_custom_color) {
          this.colors = { hex: this.user.doctor.color };
        } else {
          this.colors = { hex: "#000000" };
        }

        this.user.doctor.product_categories.forEach((cat) => {
          this.product_category_ids.push({
            label: cat.name,
            value: cat.id,
          });
        });

        this.default_available = Boolean(this.user.doctor.default_available);

        this.nickname = this.user.doctor.nickname;
        this.d_title = this.user.doctor.title;
      } else {
        this.college_number = null;
        this.default_available = true;
      }

      this.is_editing = true;
      this.is_loading = false;

      this.updateCategories();
      this.updateBoxes();
      this.getCurrentSignature();
      this.$refs.modal.show();
    },
    getDefaultConfig() {
      const clinics = Object.keys(this.clinic.clinic_names).map((x) =>
        Number(x)
      );
      return {
        enabled_clinics: clinics,
      };
    },
    getUserConfig(user) {
      const default_cfg = this.getDefaultConfig();
      if (!user || !user.config || !WabiDent.isObject(user)) {
        this.user_config = default_cfg;
      } else {
        this.user_config = user.config;
      }
    },
    getEnabledClinic(clinic_id) {
      if (!WabiDent.isObject(this.user_config)) {
        return false;
      }

      return this.user_config.enabled_clinics.indexOf(Number(clinic_id)) >= 0;
    },
    setEnabledClinic(ev, clinic_id) {
      let checked = ev.target.checked;
      if (checked) {
        this.user_config.enabled_clinics.push(Number(clinic_id));
      } else {
        this.user_config.enabled_clinics =
          this.user_config.enabled_clinics.filter((x) => {
            return x != clinic_id;
          });
      }
    },
    getCurrentSignature() {
      if (!this.is_role_doctor) return;

      axios.get(`/user/${this.user.id}/signature`).then((request) => {
        this.current_signature = request.data.signature;
      });
    },
    getFormData() {
      let ret = new FormData();

      ret.append("name", this.name);
      ret.append("email", this.email);
      ret.append("role", this.role);
      ret.append("password", this.password);
      ret.append("clinic_id", this.clinic_id);
      ret.append("college_number", this.college_number);
      ret.append("signature", this.signature_file);
      ret.append("is_active", this.is_active);
      ret.append("box_id", this.box_id);
      ret.append("title", this.d_title);
      ret.append("nickname", this.nickname);
      ret.append("default_available", this.default_available);
      ret.append("config", JSON.stringify(this.user_config));

      if (this.use_custom_color) {
        ret.append("color", this.colors.hex);
      } else {
        ret.append("color", null);
      }

      for (let cap in this.capabilities) {
        if (this.capabilities[cap]) {
          ret.append("capabilities[]", cap);
        }
      }

      this.product_category_ids.forEach((cat) => {
        ret.append("product_category_ids[]", cat.value);
      });

      return ret;
    },
    onSubmit() {
      let formData = this.getFormData();

      if (this.is_editing) {
        this.modifyUser(formData);
      } else {
        this.createNewUser(formData);
      }
    },
    signatureChanged() { },
    modifyUser(params) {
      if (!this.is_loading) {
        this.is_loading = true;
        axios
          .post(`/user/${this.user.id}`, params, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.data.error) {
              this.errorwindow.show("Error", response.data.error);
            } else {
              this.$emit("submit", response.data);
              this.msgwindow.success("Usuario modificado con éxito");
              this.$refs.modal.hide();
            }
          })
          .catch((err) => {
            console.log("[ERR] modifyUser ", err);
            this.msgwindow.error("Error modificando usuario!");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    createNewUser(params) {
      if (!this.is_loading) {
        this.is_loading = true;
        axios
          .post("/users", params)
          .then((response) => {
            this.$emit("submit", response.data);
            if (response.data.error) {
              this.errorwindow.show("Error", response.data.error, "Aceptar");
            } else {
              this.msgwindow.success("Usuario creado con éxito");
              this.$refs.modal.hide();
            }
          })
          .catch((err) => {
            console.log("[ERR] createNewUser ", err);
            this.msgwindow.error("Error creando usuario!");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss">
#clinic-show-user {
  .modal-dialog {
    max-width: 1340px;
  }
}

.clinic-show-user {
  &__signature {
    height: 50px;
  }
}
</style>
